// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"335":"8e562ac30e3b5b40f9db","503":"d3ff36f8c3fd0830df25","667":"27579caff474128c63f8"}[chunkId] + ".css";
};